export * from './homepage/homepage.component';
export * from './banner/banner.component';
export * from './event';
export * from './gallery/gallery.component';
export * from './students/students.component';
export * from './students';